<script lang="ts">
	import { onDestroy, onMount } from "svelte";
	import Idented from "../../../controls/Idented.svelte";
	import { yyyy, zzzz } from "../../../store.svelte.js";
	import { toast } from "../../../lib/toast.svelte.ts";
	import Outage from "./Outage.svelte";
	import Fa from "svelte-fa";
	import { faDownload } from "@fortawesome/free-solid-svg-icons";

	let {
		expanded = $bindable(),
		control = $bindable(),
		menuActive = $bindable(),
	} = $props();

	const url: string = yyyy.uri.api;

	// Initialize outages array in the store if it doesn't exist

	let saidi = $derived.by(() => {
		if (yyyy.outages.length === 0) return 0;
		return yyyy.outages.reduce((init, item) => {
			if (!item.metrics) return init;
			return init + item.metrics.saidi;
		}, 0);
	});

	let caidi = $derived.by(() => {
		if (yyyy.outages.length === 0) return 0;
		let cmt = yyyy.outages.reduce((init, item) => {
			if (!item.metrics) return init;
			return init + item.metrics.customer_minutes;
		}, 0);
		let ci = yyyy.outages.reduce((init, item) => {
			if (!item.metrics) return init;
			return init + item.metrics.ciii;
		}, 0);

		console.log("cmt:", cmt, "ci", ci);
		if (ci === 0) return 0;
		return cmt / ci;
	});

	let saifi = $derived.by(() => {
		let ct = 0;
		if (yyyy.outages.length === 0) return 0;
		if (yyyy.outages[0].metrics) {
			ct = yyyy.outages[0].metrics.network_count;
		}
		let ci = yyyy.outages.reduce((init, item) => {
			if (!item.metrics) return init;
			return init + item.metrics.ciii;
		}, 0);

		if (ci === 0) return 0;
		return ci / ct;
	});

	let caifi = $derived.by(() => {
		let ct = 0;
		if (yyyy.outages.length === 0) return 0;

		if (yyyy.outages[0].metrics) {
			ct = yyyy.outages.length / yyyy.outages[0].metrics.network_count;
		}

		return ct;
	});

	let ciii = $derived.by(() => {
		let ct = 0;
		if (yyyy.outages.length === 0) return 0;

		let ci = yyyy.outages.reduce((init, item) => {
			if (!item.metrics) return init;
			return init + item.metrics.ciii;
		}, 0);

		if (yyyy.outages[0].metrics) {
			ct = ci / yyyy.outages.length;
		}

		return ct;
	});

	let exportOutageData = () => {
		if (yyyy.outages && yyyy.outages.length === 0) {
			toast.warning("No outages to export");
			return;
		}

		// Create text content
		let textContent = "OUTAGE CALCULATOR REPORT\n";
		textContent += "=" + "=".repeat(50) + "\n";
		textContent += `Generated: ${new Date().toLocaleString()}\n`;
		textContent += `Livewire: ${yyyy.sesh.activeLivewire?.livewire || 'Unknown'}\n`;
		textContent += "=" + "=".repeat(50) + "\n\n";

		// Add outage details
		textContent += "OUTAGE DETAILS\n";
		textContent += "-".repeat(50) + "\n";
		yyyy.outages.forEach((outage, index) => {
			textContent += `\nOutage #${index + 1}\n`;
			textContent += `  Table: ${outage.lw_table}\n`;
			textContent += `  ID: ${outage.lw_table_pkid}\n`;
			textContent += `  Phase: ${outage.phase}\n`;
			textContent += `  Status: ${outage.status || 'N/A'}\n`;
			textContent += `  Type: ${outage.iama}\n`;
			
			if (outage.metrics) {
				textContent += `  Duration: ${outage.metrics.duration} minutes\n`;
				textContent += `  Customer Minutes: ${outage.metrics.customer_minutes}\n`;
				textContent += `  Network Count: ${outage.metrics.network_count || 'N/A'}\n`;
				textContent += `  SAIDI: ${outage.metrics.saidi}\n`;
				textContent += `  CAIDI: ${outage.metrics.caidi}\n`;
				textContent += `  SAIFI: ${outage.metrics.saifi}\n`;
				textContent += `  CAIFI: ${outage.metrics.caifi}\n`;
				textContent += `  CIII: ${outage.metrics.ciii}\n`;
			} else {
				textContent += `  Metrics: Not calculated\n`;
			}
		});

		// Add summary metrics if available
		if (yyyy.outages.some(o => o.metrics)) {
			textContent += "\n" + "=" + "=".repeat(50) + "\n";
			textContent += "SUMMARY METRICS\n";
			textContent += "-".repeat(50) + "\n";
			textContent += `Total SAIDI: ${saidi}\n`;
			textContent += `Total CAIDI: ${caidi}\n`;
			textContent += `Total SAIFI: ${saifi}\n`;
			textContent += `Total CAIFI: ${caifi}\n`;
			textContent += `Total CIII: ${ciii}\n`;
		}

		// Create blob and download
		const blob = new Blob([textContent], { type: 'text/plain' });
		const url = URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = `outage_report_${Date.now()}.txt`;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
		URL.revokeObjectURL(url);

		toast.success("Outage report exported successfully");
	};

	onMount(() => {
		yyyy.outages = yyyy.outages || [];
		zzzz.emit("startOutages");
	});

	onDestroy(() => {
		delete yyyy.outages;
		zzzz.emit("outages-cleared");
		zzzz.emit("endOutages");
	});
</script>

<div id="outage-calculator" class="card-ocontent">
	<div class="content">
		<h4 class="title is-4">Outage Calculator</h4>
		<!--
		<p class="subtitle is-6">
			Click the <span class="plus-icon-example">+</span> on map features to add them to the outage list
		</p>
-->
		{#if !yyyy.outages || yyyy.outages.length === 0}
			<div class="notification is-info is-light">
				Click on map features to see them here. Use the + button to add to outage
				calculator.
			</div>
		{/if}

		<!-- Show features when available -->
		{#if yyyy.map.idnt && yyyy.map.idnt.length > 0}
			<div style="width: 100%; margin-bottom: 20px;">
				<h5 class="subtitle is-6">Available Features:</h5>
				{#each yyyy.map.idnt as f, i (f.uniqueId)}
					<div style="height: 5px"></div>
					<Idented found={f} {i} />
				{/each}
			</div>
		{:else}
		{/if}

		<!-- Outage list -->
		<h5 class="subtitle is-6" style="margin-top: 20px;">Outage List:</h5>
		{#each yyyy.outages as outage, i (outage._)}
			<Outage {...outage} {i} />
		{:else}
			<div class="notification is-light">No outages added yet</div>
		{/each}
	</div>
</div>

{#if yyyy.outages && yyyy.outages.length !== 0}
	<table class="table is-fullwidth">
		<tbody>
			<tr>
				<th
					><abbr title="System Average Interruption Duration Index">SAIDI</abbr></th
				>
				<td>{saidi}</td>
			</tr>
			<tr>
				<th
					><abbr title="Customer Average Interruption Duration Index">CAIDI</abbr
					></th
				>
				<td>{caidi}</td>
			</tr>
			<tr>
				<th
					><abbr title="System Average Interruption Frequency Index">SAIFI</abbr></th
				>
				<td>{saifi}</td>
			</tr>
			<tr>
				<th
					><abbr title="Customer Average Interruption Frequency Index">CAIFI</abbr
					></th
				>
				<td>{caifi}</td>
			</tr>
			<tr>
				<th
					><abbr title="Customer Interrupted per Interruption Index">CIII</abbr></th
				>
				<td>{ciii}</td>
			</tr>
		</tbody>
	</table>
	
	<div style="margin-top: 1rem; text-align: center;">
		<button class="button is-info" onclick={exportOutageData}>
			<span class="icon">
				<Fa icon={faDownload} />
			</span>
			<span>Export Report</span>
		</button>
	</div>
{/if}

<style>
	#outage-calculator {
		width: 100%;
		padding: 8.775px;
		overflow-y: auto;
	}

	.plus-icon-example {
		background-color: #48c774;
		color: white;
		border-radius: 50%;
		padding: 2px 5px;
		margin: 0 2px;
		font-weight: bold;
	}
</style>
